import React from 'react'
import * as Immutable from 'immutable'
import { IAcceptor } from '../../../../../data-access/giddyUpAcceptors'
import { getAcceptor, isDog } from '../../../../../integration'
import { IAcceptorEx } from '../../../../../types'

export const SpeedMapAcceptorList: React.FC<{
  acceptors: Immutable.Iterable<number, IAcceptor>
}> = ({ acceptors }) => {
  const isDogRace =
    acceptors.count((a: IAcceptor) => isDog(getAcceptor(a.key, a.acceptorNumber))) ===
    acceptors.count()

  if (isDogRace) {
    return <div />
  }

  const nonScratched = acceptors.filter(a => !!a && !a.isGiddyupScratched)
  const lengthOffset = nonScratched.map((a: IAcceptor) => a.speedMap).min()

  const acceptorGroups = nonScratched
    // @ts-expect-error type issue to fixed later
    .sortBy((a: IAcceptor) => a.speedMapLane)
    // @ts-expect-error type issue to fixed later
    .groupBy((a: IAcceptor) => a.speedMap)
    .map((value, key) => ({ value, key }))
    .sortBy(a => a && a.key)

  const scratchedGroup = acceptors
    .filter((a: IAcceptor) => a.isGiddyupScratched)
    // @ts-expect-error type issue to fixed later
    .sortBy((a: IAcceptor) => a.acceptorNumber)

  return (
    <div className='mthalfem' style={{ maxWidth: '64em', margin: '0 auto' }}>
      {acceptorGroups
        .map((a: { value: Immutable.Iterable<number, IAcceptor>; key: number }) => (
          <AcceptorGroup
            key={a.key}
            speedMap={a.key - lengthOffset}
            acceptors={a.value}
            scratched={false}
          />
        ))
        .valueSeq()
        .toJS()}

      {scratchedGroup.count() > 0 ? (
        <AcceptorGroup key='SCR' acceptors={scratchedGroup} scratched={true} />
      ) : null}
    </div>
  )
}

// ================
// Local Components
// ================

const AcceptorGroup: React.FC<{
  speedMap?: number
  acceptors: Immutable.Iterable<number, IAcceptor>
  scratched: boolean
}> = ({ speedMap, acceptors, scratched }) => {
  return (
    <div
      data-tid-speed-map-group
      className='card prhalfem plhalfem l-faux-table l-table-fixed w100 fz-12'
    >
      <div className='l-faux-row'>
        <div data-tid-speedmap-length className='l-faux-cell l-cell-xs-2 aligntop length'>
          {scratched ? (
            <span className='lengthScratched'>SCR</span>
          ) : (
            <span className={speedMap === 0 ? 'lengthLead' : 'lengthNormal'}>
              {speedMap === 0 ? 'Lead' : `${speedMap}L`}
            </span>
          )}
        </div>
        <div className='l-faux-cell l-cell-xs-10'>
          <div
            style={{ paddingBottom: '0.25em', paddingTop: '0.25em' }}
            className='l-faux-table l-table-fixed w100 pl3em '
          >
            {acceptors
              .map((acceptor: IAcceptor) => (
                <Acceptor key={acceptor.key} acceptor={acceptor} scratched={scratched} />
              ))
              .valueSeq()
              .toJS()}
          </div>
        </div>
      </div>
    </div>
  )
}

const Acceptor: React.FC<{ acceptor: IAcceptor; scratched: boolean }> = ({
  acceptor,
  scratched,
}) => {
  const extraInfo = getAcceptor(acceptor.key, acceptor.acceptorNumber) as IAcceptorEx
  if (!extraInfo) {
    return <span>Could not match acceptor</span>
  }

  return (
    <div
      data-tid-acceptor-details
      key={acceptor.key}
      className={`l-faux-row ${scratched ? 'scratchedAcceptorText' : ''}`}
    >
      <div data-tid-acceptor-number className='l-faux-cell l-cell-xs-1 text-right'>
        {acceptor.acceptorNumber}
      </div>
      <div
        data-tid-acceptor-name
        className='l-faux-cell l-cell-xs-11 pl1em text-left'
        style={{ fill: '#fff' }}
      >
        {extraInfo.name}
      </div>
    </div>
  )
}
